import React from 'react';
import { PUBLIC_URL, LANDING_URL } from '@common/config';
import { cleanURL } from '@util';
import asyncComponentLoader from '@util/asyncComponent';
import { Route, Switch, Redirect } from 'react-router-dom';

const App = ({ match }) => {
  const matchUrl = cleanURL(`${match.url}${PUBLIC_URL}`);
  const asyncComponent = (path, prefix) => {
    return asyncComponentLoader(() => import(`${path}`), {
      prefixRoute: cleanURL(`${matchUrl}/${prefix}`),
    });
  };


  return (
    <div className="gx-page-layout portals">
      <Switch>
        <Route path={matchUrl} exact={true}>
          <Redirect to={cleanURL(`${matchUrl}/user-area`)} />
        </Route>
        <Route
          path={cleanURL(`${matchUrl}/sample`)}
          component={asyncComponent('./Sample')}
        />
        <Route
          path={cleanURL(`${matchUrl}/user-area`)}
          component={asyncComponent('./UserArea')}
        />
        <Route
          path={cleanURL(`${matchUrl}/admin-area`)}
          component={asyncComponent('./AdminArea')}
        />
        <Route
          path={cleanURL(`${matchUrl}/user-profile`)}
          component={asyncComponent('./UserProfile')}
        />
        <Route path={'*'} component={() => (window.location.href = `${LANDING_URL}/404`)} />
      </Switch>
    </div>
  );
};

export default App;
